import { createAction } from 'redux-actions';
import {
  getOrderInitialization as apiGetOrderInitialization,
  postAttachedFiles as apiPostAttachedFiles,
  postSubmitOrder as apiPostSubmitOrder
} from '../api/axis';

export const START_ORDER = 'AXIS_ORDER/START_ORDER';
export const ADD_ITEM = 'AXIS_ORDER/ADD_ITEM';
export const CHANGE_ITEM_TITLE = 'AXIS_ORDER/CHANGE_ITEM_TITLE';
export const CHANGE_ITEM_DESCRIPTION = 'AXIS_ORDER/CHANGE_ITEM_DESCRIPTION';
export const CLOSE_EDIT_ITEM = 'AXIS_ORDER/CLOSE_EDIT_ITEM';
export const REMOVE_ITEM = 'AXIS_ORDER/REMOVE_ITEM';
export const SAVE_ITEM = 'AXIS_ORDER/SAVE_ITEM';
export const START_ADD_ITEM = 'AXIS_ORDER/START_ADD_ITEM';
export const START_EDIT_ITEM = 'AXIS_ORDER/START_EDIT_ITEM';
export const ORDER_INITIALIZATION_RECEIVED = 'AXIS_ORDER/ORDER_INITIALIZATION_RECEIVED';
export const ORDER_INITIALIZATION_FAILED = 'AXIS_ORDER/ORDER_INITIALIZATION_FAILED';
export const CHANGE_TITLE = 'AXIS_ORDER/CHANGE_TITLE';
export const CHANGE_PROJECT = 'AXIS_ORDER/CHANGE_PROJECT';
export const CHANGE_PRIORITY = 'AXIS_ORDER/CHANGE_PRIORITY';
export const CHANGE_DEADLINE_DATE = 'AXIS_ORDER/CHANGE_DEADLINE_DATE';
export const CHANGE_DEADLINE_TIME = 'AXIS_ORDER/CHANGE_DEADLINE_TIME';
export const VALIDATE_ORDER = 'AXIS_ORDER/VALIDATE_ORDER';
export const SUBMIT_ORDER = 'AXIS_ORDER/SUBMIT_ORDER';
export const SUBMIT_ORDER_SUCCEEDED = 'AXIS_ORDER/SUBMIT_ORDER_SUCCEEDED';
export const SUBMIT_ORDER_FAILED = 'AXIS_ORDER/SUBMIT_ORDER_FAILED';
export const CLEAR_ORDER_ID = 'AXIS_ORDER/CLEAR_ORDER_ID';
export const ADD_FILE = 'AXIS_ORDER/ADD_FILE';
export const REMOVE_FILE = 'AXIS_ORDER/REMOVE_FILE';

export const startOrder = replaceable => dispatch => {
  dispatch(createAction(START_ORDER)({ replaceable }));

  apiGetOrderInitialization()
    .then(response => {
      const json = JSON.parse(response);
      return dispatch(createAction(ORDER_INITIALIZATION_RECEIVED)(json));
    })
    .catch(error => {
      console.log(error);
      return dispatch(createAction(ORDER_INITIALIZATION_FAILED)());
    });
};

const addFile = files => createAction(ADD_FILE)({ files });

const addItem = () => createAction(ADD_ITEM)();

const changeItemTitle = title => createAction(CHANGE_ITEM_TITLE)({ title });

const changeItemDescription = description => createAction(CHANGE_ITEM_DESCRIPTION)({ description });

const closeEditItem = () => createAction(CLOSE_EDIT_ITEM)();

const removeFile = index => createAction(REMOVE_FILE)({ index });

const removeItem = index => createAction(REMOVE_ITEM)({ index });

const saveItem = () => createAction(SAVE_ITEM)();

const startAddItem = (
  axisOrderAssetType,
  axisOrderMediaFormat,
  displayName,
  replaceableId,
  replaceableType
) =>
  createAction(START_ADD_ITEM)({
    axisOrderAssetType,
    axisOrderMediaFormat,
    displayName,
    replaceableId,
    replaceableType
  });

const startEditItem = (replaceableId) => createAction(START_EDIT_ITEM)({ replaceableId });

const changeTitle = title => createAction(CHANGE_TITLE)({ title });

const changeProject = projectId => createAction(CHANGE_PROJECT)({ projectId });

const changePriority = priorityId => createAction(CHANGE_PRIORITY)({ priorityId });

const changeDeadlineDate = date => createAction(CHANGE_DEADLINE_DATE)({ date });

const changeDeadlineTime = time => createAction(CHANGE_DEADLINE_TIME)({ time });

const validateOrder = () => createAction(VALIDATE_ORDER)();

const submitOrder = () => (dispatch, getState) => {
  dispatch(createAction(SUBMIT_ORDER)());
  const state = getState();
  const axisOrder = state.axisOrder;
  if (axisOrder.currentItem.assetTypeId !== undefined) {
    axisOrder.items.push(axisOrder.currentItem);
  }
  const order = {
    author: state.info.username,
    contextId: state.content.contextId,
    deadline: `${axisOrder.deadline.date.toString()} ${axisOrder.deadline.time.toString()}`,
    files: axisOrder.files.map(f => f.filename),
    items: axisOrder.items.map(item => ({
      assettype: Number(item.assetTypeId),
      description: item.description,
      mediaformat: Number(item.mediaFormatId),
      replaceableId: item.replaceableId,
      replaceableType: item.replaceableType,
      title: item.title,
      uuid: ''
    })),
    priority: axisOrder.selectedPriority,
    projectid: axisOrder.selectedProject,
    title: axisOrder.title
  };

  apiPostSubmitOrder(order)
    .then(response => {
      const orderResponse = JSON.parse(response);
      if (orderResponse.status.code === 200) {
        // upload files to AXIS
        apiPostAttachedFiles(orderResponse.orderguid, axisOrder.files);
        return dispatch(
          createAction(SUBMIT_ORDER_SUCCEEDED)({
            orderId: orderResponse.displayid,
            items: orderResponse.items
          })
        );
      }
      return dispatch(createAction(SUBMIT_ORDER_FAILED)());
    })
    .catch(error => {
      console.log(error);
      dispatch(createAction(SUBMIT_ORDER_FAILED)());
    });
};

const clearOrderId = () => createAction(CLEAR_ORDER_ID)();

export const actions = {
  addFile,
  addItem,
  changeDeadlineDate,
  changeDeadlineTime,
  changeItemDescription,
  changeItemTitle,
  changePriority,
  changeProject,
  changeTitle,
  clearOrderId,
  closeEditItem,
  removeFile,
  removeItem,
  saveItem,
  startAddItem,
  startEditItem,
  startOrder,
  submitOrder,
  validateOrder
};



// WEBPACK FOOTER //
// ./app/actions/axisOrder.js